import { useRef, useState } from "react";
import { message } from "antd";
import CustomLoader from "../views/common/customLoader";
import { useDispatch } from "react-redux";
import { importDataThunk } from "../store/thunks/settingsThunk";

const FileUpload = (props) => {
  const dispatch = useDispatch();
  const { role } = props;
  const [file, setFile] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const formRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      message.error("Please upload a file");
      return;
    }
    setShowLoader(true);
    const formData = new FormData();
    formData.append("role", role);
    formData.append("model", event.target.model.value);
    formData.append("file", file);
    formData.append("fileName", file.name);

    const headers = {
      role: role,
      // "Content-Type": "multipart/form-data", // Make sure to set the content type
    };

    try {
      await dispatch(importDataThunk(formData)).unwrap();

      message.success("Data Imported successfully.");
      resetForm();
    } catch (error) {
      message.error(error?.message || "There was an error!");
    } finally {
      setShowLoader(false);
    }
  };
  const handleReset = () => {
    setFile(null); // Clear the file state
    if (formRef.current) {
      formRef.current.reset(); // Reset the form fields
    }
  };
  const resetForm = () => {
    setFile(null);
    if (formRef.current) {
      formRef.current.reset();
    }
  };
  return (
    <>
      <CustomLoader showLoader={showLoader} />
      <form onSubmit={handleSubmit} ref={formRef}>
        <div className="fileUploadFieldsInnerContainer">
          <select name="model">
            <option value="">Select an option</option>
            <option value="departments">Departments</option>
            <option value="clients">Clients</option>
            <option value="processes">Processes</option>
            <option value="permissions">Permissions</option>
            <option value="sections">Sections</option>
            <option value="roles">Roles</option>
            <option value="users">Users</option>
            <option value="auditForms">Audit Forms</option>
            
          </select>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        </div>
        <div className="fileUploadButtonsContainer settingsButtons">
          <button
            className="defaultBtn"
            type="submit"
            role="button"
            aria-expanded="false"
            aria-controls="collapseContent"
          >
            Import
          </button>
          <button
            type="button"
            className="defaultGreyBtn defaultBtn"
            onClick={handleReset}
          >
            Reset
          </button>
        </div>
      </form>
    </>
  );
};

export default FileUpload;
